<template>
  <div class="card-wrapper white-label d-flex flex-column position-relative h-100">
    <h2 class="plan-title font-outfit-semi-bold">
      {{ $t('pages.pricing.whiteLabel.title') }}
    </h2>
    <p class="plan-description mt-0">
      {{ $t('pages.pricing.whiteLabel.description') }}
    </p>

    <div
      class="quote-slot d-flex flex-column justify-content-center"
      :class="{ 'with-save': hasSaveText }"
    >
      <p class="quote-text font-outfit-bold m-0">
        {{ $t('pages.pricing.whiteLabel.getAQuote') }}
      </p>
    </div>

    <div class="actions">
      <div class="input-number-spacer" />
      <ib-button
        class="cta-button w-100"
        variant="blue"
        size="sm"
        @click="$emit('contact')"
      >
        {{ $t('pages.pricing.whiteLabel.contactUs') }}
      </ib-button>
    </div>

    <div class="features text-left">
      <h5 class="title font-outfit-medium">
        {{ $t('pages.pricing.whiteLabel.featuresTitle') }}
      </h5>
      <ul>
        <li
          v-for="feature in features"
          :key="feature.id"
          class="active font-outfit-light"
        >
          <ib-tooltip :content="feature.hint" :dark="true">
            <span>{{ feature.text }}</span>
          </ib-tooltip>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhiteLabelCard',

  props: {
    period: {
      type: String,
      default: 'annual'
    },
    plan: {
      validator: value => typeof value === 'object' || value === null,
      default: null
    },
    price: {
      type: [Number, String],
      default: null
    }
  },

  computed: {
    hasSaveText () {
      return this.period === 'annual' || this.period === 'lifetime'
    },

    features () {
      return [
        {
          id: 1,
          text: this.$t('pages.pricing.whiteLabel.featuresName.customLogo'),
          hint: this.$t('pages.pricing.whiteLabel.featuresTexts.customLogo')
        },
        {
          id: 2,
          text: this.$t('pages.pricing.whiteLabel.featuresName.customDomain'),
          hint: this.$t('pages.pricing.whiteLabel.featuresTexts.customDomain')
        },
        {
          id: 3,
          text: this.$t('pages.pricing.whiteLabel.featuresName.userManagement'),
          hint: this.$t('pages.pricing.whiteLabel.featuresTexts.userManagement')
        },
        {
          id: 4,
          text: this.$t('pages.pricing.whiteLabel.featuresName.allFeaturesIncluded'),
          hint: this.$t('pages.pricing.whiteLabel.featuresTexts.allFeaturesIncluded')
        },
        {
          id: 5,
          text: this.$t('pages.pricing.whiteLabel.featuresName.onboardingSupport'),
          hint: this.$t('pages.pricing.whiteLabel.featuresTexts.onboardingSupport')
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
$tmp-color-blue: var(--color-primary);

.card-wrapper {
  background-color: $color-white;
  border: 3px solid #bbc9e4;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 30px 15px;

  @include media-breakpoint-between($md, $lg) {
    padding-bottom: 24px;
  }

  h2 {
    font-size: 30px;
  }

  .plan-title {
    margin: 0 0 10px;
  }

  .plan-description {
    font-size: 14px;

    @include media-breakpoint-up($md) {
      font-size: 13px;
    }

    @include media-breakpoint-up($lg) {
      font-size: 14px;
    }
  }

  .quote-slot {
    min-height: 183px;

    &.with-save {
      min-height: 245px;
    }

    .quote-text {
      color: $tmp-color-blue;
      font-size: 38px;
      line-height: 1.1;

      @include media-breakpoint-up($md) {
        font-size: 30px;
      }

      @include media-breakpoint-up($lg) {
        font-size: 38px;
      }
    }
  }

  .actions {
    padding: 0 10px;

    .input-number-spacer {
      height: 42px;
      margin-bottom: 10px;
    }

    .cta-button {
      height: 42px;

      ::v-deep {
        span {
          font-size: 16px;
        }
      }
    }
  }

  .features {
    padding-left: 10px;

    .title {
      font-size: 16px;
      margin: 20px 0 21px;
    }

    ul {
      list-style: none;
      padding-left: 25px;
      margin: 0;

      li {
        position: relative;
        font-size: 14px;
        text-decoration: underline;
        text-decoration-style: dashed;
        text-underline-offset: 5px;
        color: rgb(8, 30, 74) !important;

        @include media-breakpoint-up($md) {
          font-size: 13px;
        }

        @include media-breakpoint-up($lg) {
          font-size: 14px;
        }

        &:not(:last-child) {
          margin-bottom: 12px;
        }

        &::before {
          content: '';
          position: absolute;
          right: 100%;
          width: 16px;
          height: 100%;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          margin-right: 9px;
          background-image: url('~@/assets/img/pricing/plans/circle-xmark.svg');
          cursor: auto;
        }

        &.active {
          cursor: pointer;
          color: $color-black;

          &::before {
            background-image: url('~@/assets/img/pricing/plans/circle-check.svg');
          }
        }
      }
    }
  }
}
</style>
